// src/i18n/locales/en/productSettings.ts

export const productSettings = {
  // Page Header
  title: 'Product Settings',
  subtitle: 'Manage affiliate system and shopping list mode',

  // Affiliate Toggle Section
  affiliateSystem: 'Affiliate System',
  masterSwitch: 'Master Switch',
  
  // Status Messages
  status: {
    enabled: 'Smart Shopping Enabled',
    disabled: 'Simple List Mode Active',
    enabledDescription: 'VIP users can access Smart Shopping mode with real product cards, prices, and affiliate links.',
    disabledDescription: 'All users see Simple List mode with estimated prices only. Smart Shopping is disabled.',
  },

  // Toggle Labels
  toggleLabel: {
    on: 'Enabled',
    off: 'Disabled',
  },

  // Info Card
  infoCard: {
    title: 'How does this work?',
    simpleMode: {
      title: 'Simple List Mode',
      description: 'Shows only product names and quantities with estimated prices. No supermarket names or product images.',
    },
    smartMode: {
      title: 'Smart Shopping Mode (VIP)',
      description: 'Shows real product cards from Migros/Coop with exact prices, images, and "Buy Now" buttons with affiliate links.',
    },
    note: 'When the master switch is OFF, all users (BASIC + VIP) are locked into Simple List mode.',
  },

  // Impact Notice
  impactNotice: {
    title: 'What happens when you change this?',
    enable: 'VIP users will be able to toggle between Simple List and Smart Shopping modes.',
    disable: 'All users will be switched to Simple List mode. VIP toggle will be locked.',
  },

  // Stats Cards
  stats: {
    vipUsers: 'VIP Users',
    basicUsers: 'BASIC Users',
    totalUsers: 'Total Users',
    affiliateClicks: 'Affiliate Clicks',
    thisMonth: 'This month',
  },

  // Actions
  save: 'Save Changes',
  cancel: 'Cancel',
  confirm: 'Confirm',

  // Confirmation Modal
  confirmModal: {
    enableTitle: 'Enable Affiliate System?',
    disableTitle: 'Disable Affiliate System?',
    enableMessage: 'VIP users will gain access to Smart Shopping mode with product cards and affiliate links.',
    disableMessage: 'All users will be switched to Simple List mode. This will affect VIP user experience.',
    confirm: 'Yes, Continue',
    cancel: 'Cancel',
  },

  // Toast Messages
  toast: {
    enabled: 'Affiliate system enabled - VIP users can now access Smart Shopping mode',
    disabled: 'Affiliate system disabled - All users switched to Simple List mode',
    error: 'Failed to update affiliate system',
  },
};